<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/automation.png)"
  >
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Sensör Üretimi</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix" aria-label="breadcrumb">
            <li><a href="/">Anasayfa</a></li>
            <li class="active" aria-current="page">Sensör Üretimi</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="page-section" id="portfolio">
    <div class="container">
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <h2 class="text">Profesyonel Sıcaklık Sensörleri</h2>
        <div class="line"></div>
      </div>

      <div class="row">
       <div class="col-lg-10 offset-lg-1 col-md-12 text-center">
           <h3 class="section-subtitle">Müşteriye Özel Çözümler</h3>
          <p>
            Otomasyon sistemlerinde güvenilir ve hassas sıcaklık sensörleri kritik öneme sahiptir.
            Firmamız, özel ihtiyaçlarınıza uygun olarak çeşitli tiplerde ve farklı uçlarla donatılmış, özelleştirilebilir sıcaklık sensörleri sunmaktadır.
          </p>
    <h3 class="section-subtitle">Farklı Tipler, Uçlar ve Kablolar</h3>
          <p>
            Endüstriyel tesislerden laboratuvarlara kadar geniş uygulama alanlarına sahip sensörlerimiz,
            termistör, termokupl, PT100, PT1000 gibi farklı tiplerde; uçlu, uçsuz gibi alternatiflerde; farklı kablo boylarında sunulmaktadır.
          </p>
    <h3 class="section-subtitle">Özel Tasarım ve Üretim</h3>
          <p>
            İntek olarak ihtiyaçlarınıza özel sensörler tasarlıyor ve üretiyoruz. Uzman ekibimiz sizin için en uygun teknik çözümü geliştirir.
          </p>
    <h3 class="section-subtitle">Yüksek Kalite ve Güvenilirlik</h3>
          <p>
            Tüm ürünlerimiz endüstri standartlarına uygundur. Kalite kontrol süreçlerinden geçerek uzun ömürlü ve güvenli kullanım sunar.
          </p>
    <h3 class="section-subtitle">Sizin İçin Buradayız</h3>
          <p>
            Sıcaklık sensörü ihtiyaçlarınız için bize ulaşın. Size özel çözümlerle yanınızdayız.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="text-uppercase line-wrapper mt-5">
          <h2 class="text">Galeri</h2>
          <div class="line"></div>
        </div>

        <div
          class="col-lg-3 col-sm-6 mb-3"
          v-for="(item, index) in sensorList"
          :key="index"
        >
          <div class="portfolio-item">
            <a
              class="portfolio-link"
              data-bs-toggle="modal"
              :href="'#portfolioModal' + index"
            >
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
              <img
                :src="item.logo"
                :alt="item.baslik || 'Sensör Ürünü Görseli'" style="max-width: 100%; height: auto; border-radius: 8px;"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <Footer />

  <!-- Modal galerisi -->
  <div
    class="portfolio-modal modal fade"
    v-for="(item, index) in sensorList"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-bs-dismiss="modal">
          <img src="images/close-icon.svg" alt="Kapat" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
                <img class="img-fluid" 
                  :src="item.logo"
                  :alt="item.baslik || 'Sensör Detay Görseli'" loading="lazy" decoding="async" 
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    Navbar,
    ScrollButton,
    Footer,
    FontAwesomeIcon,
  },
  setup() {
    const sensorList = ref([]);

    useHead({
      title: 'Sensör Üretimi | Özel Sıcaklık Sensörleri | İntek Electronic',
      meta: [
        {
          name: 'description',
          content: 'İntek Electronic olarak PT100, PT1000 ve termokupl gibi hassas sıcaklık sensörleri üretiyoruz. Müşteri taleplerine özel, farklı kablo ve uç seçenekleriyle özelleştirilmiş çözümler sunuyoruz.'
        },
        {
          name: 'keywords',
          content: 'sıcaklık sensörü, pt100, pt1000, termokupl, sensör üretimi, özel sensör, otomasyon sensörü, kablolu sensör, intek'
        },
        {
          property: 'og:title',
          content: 'Sensör Üretimi | Özel Sıcaklık Sensörleri | İntek Electronic'
        },
        {
          property: 'og:description',
          content: 'PT100 ve PT1000 gibi endüstriyel sıcaklık sensörleri, ihtiyaca özel tasarım ve güvenilir üretim.'
        },
        {
          property: 'og:image',
          content: 'https://www.intekelectronic.com.tr/images/automation.png'
        },
        {
          property: 'og:url',
          content: 'https://www.intekelectronic.com.tr/sensor-uretimi'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.intekelectronic.com.tr/sensor-uretimi'
        }
      ]
    });

    onMounted(async () => {
      const q = query(collection(firestore, "sensor"), where("durum", "==", true));
      const querySnapshot = await getDocs(q);
      const veri = [];
      querySnapshot.forEach((doc) => {
        veri.push({ ...doc.data(), id: doc.id });
      });
      sensorList.value = veri;
    });

    return {
      sensorList,
    };
  },
};
</script>

<style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
.portfolio-caption {
  text-align: center;
  margin-top: 0.5rem;
}
.section-subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #222;
}

p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 1.5rem;
  text-align: center;
}
@media (max-width: 768px) {
  .title-column h1 {
    font-size: 1.6rem;
    text-align: center;
  }
  .bread-crumb {
    justify-content: center;
    font-size: 0.9rem;
  }
}
</style>


